export default "/fonts/vendor/@fontsource/inter/files/inter-greek-400-normal.woff2?94fd6d5b2b3cd70f251686d025df277b";